/**
 * NotificationEarlyAccessReceivedItem
 *
 * earlyAccessContentReceived — `notification_early_access_content_received.dart:39-66`.
 * Title: `{name}`. Subtitle: `Allowed you Early Access on a scheduled video`.
 *
 * NOTE (Flutter parity): both the avatar image AND the `onUserTap` handler use
 * `mediaInfo.firebaseId` (the content owner), NOT `usersInfo.userId`
 * (`notification_early_access_content_received.dart:66-72`). Trailing thumbnail
 * from `mediaInfo`.
 */
import React from 'react';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { NotificationRowLayout } from '../NotificationRowLayout';
import { NotificationAvatar } from './shared/NotificationAvatar';
import { NotificationMediaThumbnail } from './shared/NotificationMediaThumbnail';
import type { NotificationItemProps } from './notificationItemProps';

export const NotificationEarlyAccessReceivedItem: React.FC<NotificationItemProps> = ({
  notification,
  onUserTap,
  onItemTap,
  onItemMediaTap,
}) => {
  const { l10n } = useLocale();
  const n = l10n.inbox.notifications;

  const { info } = notification;
  const mediaInfo = info.mediaInfo;
  const ownerId = mediaInfo?.firebaseId ?? '';

  return (
    <NotificationRowLayout
      leading={<NotificationAvatar userId={ownerId} alt={info.usersInfo.name} />}
      title={info.usersInfo.name}
      subtitle={n.earlyAccessReceivedBody}
      trailing={mediaInfo ? <NotificationMediaThumbnail mediaInfo={mediaInfo} /> : undefined}
      onItemTap={onItemTap ? () => onItemTap(notification) : undefined}
      onLeadingTap={onUserTap ? () => onUserTap(ownerId) : undefined}
      onTrailingTap={onItemMediaTap ? () => onItemMediaTap(notification) : undefined}
    />
  );
};
